import { Action } from '@ngrx/store';
import { PaginationState, SearchPageResultState } from '../../../../core/features/store/base-feature-state';
import { DeliveryAddressSearchResult } from '../../../../core/model';
import { loaderReducer } from '../../../../core/state/utils/loader';
import { SoldToActions } from '../actions';
import { DELIVERY_ADDRESS } from '../sold-to-state';
import { reducer as deliveryAddressEntriesReducer } from './sold-to-delivery-address-entries.reducer';

export const initialState: PaginationState<SearchPageResultState> = {
  lastUpdateTime: undefined,
  pages: {},
  pagination: undefined,
  sorts: [],
};

export function reducer(state = initialState, action: Action): any {
  switch (action.type) {
    case SoldToActions.DeliveryAddressActionTypes.LoadDeliveryAddresses:
    case SoldToActions.DeliveryAddressActionTypes.LoadDeliveryAddressesFail: {
      const deliveryAddressesAction = <SoldToActions.DeliveryAddressActions>action;
      const searchParams = deliveryAddressesAction.searchParams;
      const loaderState = loaderReducer<SearchPageResultState>(DELIVERY_ADDRESS, deliveryAddressEntriesReducer)(
        undefined,
        deliveryAddressesAction
      );
      return {
        ...state,
        pages: {
          ...state.pages,
          [searchParams.page]: loaderState,
        },
      };
    }
    case SoldToActions.DeliveryAddressActionTypes.LoadDeliveryAddressesSuccess: {
      const successAction = <SoldToActions.LoadDeliveryAddressesSuccess>action;
      const payload: DeliveryAddressSearchResult = successAction.payload;
      const searchParams = successAction.searchParams;
      const loaderState = loaderReducer<SearchPageResultState>(DELIVERY_ADDRESS, deliveryAddressEntriesReducer)(
        { ...state.pages[searchParams.page] },
        successAction
      );
      return {
        ...state,
        lastUpdateTime: new Date().toISOString(),
        pagination: payload.pagination,
        sorts: payload.sorts,
        pages: {
          ...state.pages,
          [searchParams.page]: loaderState,
        },
      };
    }
    default:
      return state;
  }
}
